"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsDateRangePicker = void 0;
var _react = _interopRequireWildcard(require("react"));
var _DatePicker = require("@mui/x-date-pickers/DatePicker");
var _material = require("@mui/material");
var _AdapterMoment = require("@mui/x-date-pickers/AdapterMoment");
var _xDatePickers = require("@mui/x-date-pickers");
var _TimeZone = require("../../constants/TimeZone");
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
require("moment/locale/pt-br");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const DmsDateRangePicker = _ref => {
  let {
    maxValue = null,
    minValue = null,
    startValue: initialStartValue = null,
    endValue: initialEndValue = null,
    onChange = () => {}
  } = _ref;
  const [startValue, setStartValue] = (0, _react.useState)(initialStartValue);
  const [endValue, setEndValue] = (0, _react.useState)(initialEndValue);
  (0, _react.useEffect)(() => {
    setStartValue(initialStartValue);
  }, [initialStartValue]);
  (0, _react.useEffect)(() => {
    setEndValue(initialEndValue);
  }, [initialEndValue]);
  const onChangeStartInput = value => {
    if (endValue && value > endValue) setEndValue(null);
    setStartValue(value);
    onChange({
      startDate: value,
      endDate: endValue
    });
  };
  const onChangeEndInput = value => {
    if (startValue && value < startValue) setStartValue(null);
    setEndValue(value);
    onChange({
      startDate: startValue,
      endDate: value
    });
  };
  return /*#__PURE__*/_react.default.createElement(_xDatePickers.LocalizationProvider, {
    dateAdapter: _AdapterMoment.AdapterMoment,
    adapterLocale: "pt-br"
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    container: true,
    spacing: 2,
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_DatePicker.DatePicker, {
    label: _reactIntlUniversal.default.get("StartDate").d("Start Date"),
    value: startValue,
    onChange: value => onChangeStartInput(value),
    minDate: minValue,
    maxDate: endValue,
    format: "DD/MM/YYYY",
    timezone: _TimeZone.TIME_ZONE.UTC
  })), /*#__PURE__*/_react.default.createElement(_material.Grid, {
    item: true
  }, /*#__PURE__*/_react.default.createElement(_DatePicker.DatePicker, {
    label: _reactIntlUniversal.default.get("EndDate").d("End Date"),
    value: endValue,
    onChange: value => onChangeEndInput(value),
    minDate: startValue,
    maxDate: maxValue,
    format: "DD/MM/YYYY",
    timezone: _TimeZone.TIME_ZONE.UTC
  }))));
};
exports.DmsDateRangePicker = DmsDateRangePicker;